import React from 'react';
import Swal from 'sweetalert2';

import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleLeft, faAngleDoubleRight, faAngleLeft, faAngleRight, faCalendarAlt, faEdit, faFilter, faHashtag, faPlus, faSync, faTrashAlt } from '@fortawesome/free-solid-svg-icons';

class Listar extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        load: '',
        datosCargados: false,
        archivo: '',
        anosCatastro: [],
        anosFacturacion: [],
        anosRecaudo: [],
        anosRefacturacion: [],
        archivosCatastro: [],
        archivosFacturacion: [],
        archivosRecaudo: [],
        archivosRefacturacion: []
    }

    cargarAnos() {
        Swal.showLoading();
        authAxios.get("archivos_catastro/anos_archivos")
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({ datosCargados: true, anosCatastro: datosRespuesta.data.data });
            })
            .catch(console.log);
        authAxios.get("archivos_facturacion/anos_archivos")
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({ datosCargados: true, anosFacturacion: datosRespuesta.data.data });
            })
            .catch(console.log);
        authAxios.get("archivos_recaudo/anos_archivos")
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({ datosCargados: true, anosRecaudo: datosRespuesta.data.data });
            })
            .catch(console.log);
        authAxios.get("archivos_refacturacion/anos_archivos")
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({ datosCargados: true, anosRefacturacion: datosRespuesta.data.data });
                Swal.close();
            })
            .catch(console.log);
    }

    cargarArchivos = (tipoArchivo, page) => {
        Swal.showLoading();
        switch (tipoArchivo) {
            case 'CATA':
                this.setState({ archivo: 'CATA'});
                let anosCatastro = document.getElementById('anosCatastro').value;
                let nombreArchivoCatastro = document.getElementById('nombreArchivoCatastro').value;
                if (nombreArchivoCatastro == '') {
                    nombreArchivoCatastro = 0;
                }
                authAxios.get("archivos_catastro/cargar_archivos/" + nombreArchivoCatastro + "/" + anosCatastro + "?page=" + page)
                .then((datosRespuesta) => {
                    console.log(datosRespuesta);
                    Swal.close();
                    var status = datosRespuesta.data.status;
                    if (status) {
                        Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                        window.localStorage.clear();
                        window.location.href = '/';
                    }
                    this.setState({ datosCargados: true, load: '', archivosCatastro: datosRespuesta.data.data, paginaCatastro: datosRespuesta.data.total, ultimoCatastro: datosRespuesta.data.last_page, actualCatastro: datosRespuesta.data.current_page });
                })
                .catch(console.log);
                break;
            case 'FACT':
                this.setState({ archivo: 'FACT'});
                let anosFacturacion = document.getElementById('anosFacturacion').value;
                let nombreArchivoFacturacion = document.getElementById('nombreArchivoFacturacion').value;
                if (nombreArchivoFacturacion == '') {
                    nombreArchivoFacturacion = 0;
                }
                authAxios.get("archivos_facturacion/cargar_archivos/" + nombreArchivoFacturacion + "/" + anosFacturacion + "?page=" + page)
                .then((datosRespuesta) => {
                    console.log(datosRespuesta);
                    Swal.close();
                    var status = datosRespuesta.data.status;
                    if (status) {
                        Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                        window.localStorage.clear();
                        window.location.href = '/';
                    }
                    this.setState({ datosCargados: true, load: '', archivosFacturacion: datosRespuesta.data.data, paginaFacturacion: datosRespuesta.data.total, ultimoFacturacion: datosRespuesta.data.last_page, actualFacturacion: datosRespuesta.data.current_page });
                })
                .catch(console.log);
                break;
            case 'RECA':
                this.setState({ archivo: 'RECA'});
                let anosRecaudo = document.getElementById('anosRecaudo').value;
                let nombreArchivoRecaudo = document.getElementById('nombreArchivoRecaudo').value;
                if (nombreArchivoRecaudo == '') {
                    nombreArchivoRecaudo = 0;
                }
                authAxios.get("archivos_recaudo/cargar_archivos/" + nombreArchivoRecaudo + "/" + anosRecaudo + "?page=" + page)
                .then((datosRespuesta) => {
                    console.log(datosRespuesta);
                    Swal.close();
                    var status = datosRespuesta.data.status;
                    if (status) {
                        Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                        window.localStorage.clear();
                        window.location.href = '/';
                    }
                    this.setState({ datosCargados: true, load: '', archivosRecaudo: datosRespuesta.data.data, paginaRecaudo: datosRespuesta.data.total, ultimoRecaudo: datosRespuesta.data.last_page, actualRecaudo: datosRespuesta.data.current_page });
                })
                break;
            case 'REFA':
                this.setState({ archivo: 'REFA'});
                let anosRefacturacion = document.getElementById('anosRefacturacion').value;
                let nombreArchivoRefacturacion = document.getElementById('nombreArchivoRefacturacion').value;
                if (nombreArchivoRefacturacion == '') {
                    nombreArchivoRefacturacion = 0;
                }
                authAxios.get("archivos_refacturacion/cargar_archivos/" + nombreArchivoRefacturacion + "/" + anosRefacturacion + "?page=" + page)
                .then((datosRespuesta) => {
                    console.log(datosRespuesta);
                    Swal.close();
                    var status = datosRespuesta.data.status;
                    if (status) {
                        Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                        window.localStorage.clear();
                        window.location.href = '/';
                    }
                    this.setState({ datosCargados: true, load: '', archivosRefacturacion: datosRespuesta.data.data, paginaRefacturacion: datosRespuesta.data.total, ultimoRefacturacion: datosRespuesta.data.last_page, actualRefacturacion: datosRespuesta.data.current_page });
                })
                break;
        }
    }

    componentDidMount() {
        this.cargarAnos();
    }
    render() {
        const { load, archivo,
                anosCatastro, anosFacturacion, anosRecaudo, anosRefacturacion,
                archivosCatastro, archivosFacturacion, archivosRecaudo, archivosRefacturacion,
                paginaCatastro, ultimoCatastro, actualCatastro,
                paginaFacturacion, ultimoFacturacion, actualFacturacion,
                paginaRecaudo, ultimoRecaudo, actualRecaudo,
                paginaRefacturacion, ultimoRefacturacion, actualRefacturacion
            } = this.state;
        return (
            <div className="content">
                <div className="container-fluid">
                    <br />
                    <div className="card">
                        <div className="card-header">
                            <Link className="btn btn-success btn-sm" to={"/AddCargueLiquidaciones"}><FontAwesomeIcon icon={faPlus} />&nbsp;&nbsp;Nuevo Cargue</Link>
                        </div>
                        <div className="card-body">
                            <h4>Lista Archivos Cargados Operadores de Red</h4>
                            <hr />
                            <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link active" id="pills-catastro-tab" data-bs-toggle="pill" data-bs-target="#pills-catastro" type="button" role="tab" aria-controls="pills-catastro" aria-selected="true">CATASTRO</button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link" id="pills-facturacion-tab" data-bs-toggle="pill" data-bs-target="#pills-facturacion" type="button" role="tab" aria-controls="pills-facturacion" aria-selected="false">FACTURACIÓN</button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link" id="pills-recaudo-tab" data-bs-toggle="pill" data-bs-target="#pills-recaudo" type="button" role="tab" aria-controls="pills-recaudo" aria-selected="false">RECAUDO</button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link" id="pills-refacturacion-tab" data-bs-toggle="pill" data-bs-target="#pills-refacturacion" type="button" role="tab" aria-controls="pills-refacturacion" aria-selected="false">REFACTURACIÓN</button>
                                </li>
                            </ul>
                            <div className="tab-content" id="pills-tabContent">
                                <div className="tab-pane fade show active" id="pills-catastro" role="tabpanel" aria-labelledby="pills-catastro-tab">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-xl-12">
                                                    <div className='row g-3'>
                                                        <div className="col-xl-2">
                                                            <select name="anosCatastro" id="anosCatastro"
                                                                className={"form-select form-select-sm"}
                                                                onChange={this.cambioValor}>
                                                                {
                                                                    anosCatastro.map((itemAnosCatastro) => (
                                                                        <option key={itemAnosCatastro.ANO_FACTURA} value={itemAnosCatastro.ANO_FACTURA}>{itemAnosCatastro.ANO_FACTURA}</option>
                                                                    ))
                                                                }
                                                            </select>
                                                        </div>
                                                        <div className="col-xl-4">
                                                            <input style={{ textTransform: 'uppercase' }} type="text" id="nombreArchivoCatastro" name="nombreArchivoCatastro" placeholder="Archivo" className="form-control form-control-sm" />
                                                        </div>
                                                        <div className="col-xl-3">
                                                            <button id="buttonFiltrarCatastro" name="buttonFiltrarCatastro" className="btn btn-secondary btn-sm" onClick={() => this.cargarArchivos('CATA', 1)}><FontAwesomeIcon icon={faFilter} />&nbsp;&nbsp;Filtrar</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <br />
                                            <div className="row">
                                                <table className="table table-hover table-condensed table-sm">
                                                    <thead className="thead-inverse">
                                                        <tr>
                                                            <th className="align-middle">MES</th>
                                                            <th className="align-middle">DEPARTAMENTO</th>
                                                            <th className="align-middle">MUNICIPIO</th>
                                                            <th className="align-middle">NOMBRE ARCHIVO</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            archivosCatastro.map((itemArchivosCatastro) => (
                                                                <tr key={itemArchivosCatastro.ID_TABLA}>
                                                                    <td>{itemArchivosCatastro.MES_FACTURA}</td>
                                                                    <td>{itemArchivosCatastro.DEPARTAMENTO}</td>
                                                                    <td>{itemArchivosCatastro.MUNICIPIO}</td>
                                                                    <td>{itemArchivosCatastro.RUTA}</td>
                                                                </tr>
                                                            ))
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                            <nav aria-label="Page navigation example">
                                                <ul className="pagination">
                                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.cargarArchivos('CATA', 1)}><FontAwesomeIcon icon={faAngleDoubleLeft} /></a></li>
                                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.cargarArchivos('CATA', actualCatastro - 1)}><FontAwesomeIcon icon={faAngleLeft} /></a></li>
                                                    {(() => {
                                                        let p = [];
                                                        p.push(<li className="page-item" key={actualCatastro}><a className="page-link" href="#" onClick={() => this.BuscarArrayResultado(actualCatastro)}>{actualCatastro}</a></li>);
                                                        return p;
                                                    })()}
                                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.cargarArchivos('CATA', actualCatastro + 1)}><FontAwesomeIcon icon={faAngleRight} /></a></li>
                                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.cargarArchivos('CATA', ultimoCatastro)}><FontAwesomeIcon icon={faAngleDoubleRight} /></a></li>
                                                </ul>
                                            </nav>
                                        </div>
                                        <div className="card-footer text-muted">
                                            <b>Pagina</b> <span className="badge bg-primary">{actualCatastro}</span> <b>de</b> <span className="badge bg-primary">{ultimoCatastro}</span> | <b>Registros</b> <span className="badge bg-success">{paginaCatastro}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane fade" id="pills-facturacion" role="tabpanel" aria-labelledby="pills-facturacion-tab">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-xl-12">
                                                    <div className='row g-3'>
                                                        <div className="col-xl-2">
                                                            <select name="anosFacturacion" id="anosFacturacion"
                                                                className={"form-select form-select-sm"}
                                                                onChange={this.cambioValor}>
                                                                {
                                                                    anosFacturacion.map((itemAnosFacturacion) => (
                                                                        <option key={itemAnosFacturacion.ANO_FACTURA} value={itemAnosFacturacion.ANO_FACTURA}>{itemAnosFacturacion.ANO_FACTURA}</option>
                                                                    ))
                                                                }
                                                            </select>
                                                        </div>
                                                        <div className="col-xl-4">
                                                            <input style={{ textTransform: 'uppercase' }} type="text" id="nombreArchivoFacturacion" name="nombreArchivoFacturacion" placeholder="Archivo" className="form-control form-control-sm" />
                                                        </div>
                                                        <div className="col-xl-3">
                                                            <button id="buttonFiltrarFacturacion" name="buttonFiltrarFacturacion" className="btn btn-secondary btn-sm" onClick={() => this.cargarArchivos('FACT', 1)}><FontAwesomeIcon icon={faFilter} />&nbsp;&nbsp;Filtrar</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <br />
                                            <div className="row">
                                                <table className="table table-hover table-condensed table-sm">
                                                    <thead className="thead-inverse">
                                                        <tr>
                                                            <th className="align-middle">MES</th>
                                                            <th className="align-middle">DEPARTAMENTO</th>
                                                            <th className="align-middle">MUNICIPIO</th>
                                                            <th className="align-middle">NOMBRE ARCHIVO</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            archivosFacturacion.map((itemArchivosFacturacion) => (
                                                                <tr key={itemArchivosFacturacion.ID_TABLA}>
                                                                    <td>{itemArchivosFacturacion.MES_FACTURA}</td>
                                                                    <td>{itemArchivosFacturacion.DEPARTAMENTO}</td>
                                                                    <td>{itemArchivosFacturacion.MUNICIPIO}</td>
                                                                    <td>{itemArchivosFacturacion.RUTA}</td>
                                                                </tr>
                                                            ))
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                            <nav aria-label="Page navigation example">
                                                <ul className="pagination">
                                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.cargarArchivos('FACT', 1)}><FontAwesomeIcon icon={faAngleDoubleLeft} /></a></li>
                                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.cargarArchivos('FACT', actualFacturacion - 1)}><FontAwesomeIcon icon={faAngleLeft} /></a></li>
                                                    {(() => {
                                                        let p = [];
                                                        p.push(<li className="page-item" key={actualFacturacion}><a className="page-link" href="#" onClick={() => this.BuscarArrayResultado(actualFacturacion)}>{actualFacturacion}</a></li>);
                                                        return p;
                                                    })()}
                                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.cargarArchivos('FACT', actualFacturacion + 1)}><FontAwesomeIcon icon={faAngleRight} /></a></li>
                                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.cargarArchivos('FACT', ultimoFacturacion)}><FontAwesomeIcon icon={faAngleDoubleRight} /></a></li>
                                                </ul>
                                            </nav>
                                        </div>
                                        <div className="card-footer text-muted">
                                            <b>Pagina</b> <span className="badge bg-primary">{actualFacturacion}</span> <b>de</b> <span className="badge bg-primary">{ultimoFacturacion}</span> | <b>Registros</b> <span className="badge bg-success">{paginaFacturacion}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane fade" id="pills-recaudo" role="tabpanel" aria-labelledby="pills-recaudo-tab">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-xl-12">
                                                    <div className='row g-3'>
                                                        <div className="col-xl-2">
                                                            <select name="anosRecaudo" id="anosRecaudo"
                                                                className={"form-select form-select-sm"}
                                                                onChange={this.cambioValor}>
                                                                {
                                                                    anosRecaudo.map((itemAnosRecaudo) => (
                                                                        <option key={itemAnosRecaudo.ANO_FACTURA} value={itemAnosRecaudo.ANO_FACTURA}>{itemAnosRecaudo.ANO_FACTURA}</option>
                                                                    ))
                                                                }
                                                            </select>
                                                        </div>
                                                        <div className="col-xl-4">
                                                            <input style={{ textTransform: 'uppercase' }} type="text" id="nombreArchivoRecaudo" name="nombreArchivoRecaudo" placeholder="Archivo" className="form-control form-control-sm" />
                                                        </div>
                                                        <div className="col-xl-3">
                                                            <button id="buttonFiltrarRecaudo" name="buttonFiltrarRecaudo" className="btn btn-secondary btn-sm" onClick={() => this.cargarArchivos('RECA', 1)}><FontAwesomeIcon icon={faFilter} />&nbsp;&nbsp;Filtrar</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <br />
                                            <div className="row">
                                                <table className="table table-hover table-condensed table-sm">
                                                    <thead className="thead-inverse">
                                                        <tr>
                                                            <th className="align-middle">MES</th>
                                                            <th className="align-middle">DEPARTAMENTO</th>
                                                            <th className="align-middle">MUNICIPIO</th>
                                                            <th className="align-middle">NOMBRE ARCHIVO</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            archivosRecaudo.map((itemArchivosRecaudo) => (
                                                                <tr key={itemArchivosRecaudo.ID_TABLA}>
                                                                    <td>{itemArchivosRecaudo.MES_FACTURA}</td>
                                                                    <td>{itemArchivosRecaudo.DEPARTAMENTO}</td>
                                                                    <td>{itemArchivosRecaudo.MUNICIPIO}</td>
                                                                    <td>{itemArchivosRecaudo.RUTA}</td>
                                                                </tr>
                                                            ))
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                            <nav aria-label="Page navigation example">
                                                <ul className="pagination">
                                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.cargarArchivos('RECA', 1)}><FontAwesomeIcon icon={faAngleDoubleLeft} /></a></li>
                                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.cargarArchivos('RECA', actualRecaudo - 1)}><FontAwesomeIcon icon={faAngleLeft} /></a></li>
                                                    {(() => {
                                                        let p = [];
                                                        p.push(<li className="page-item" key={actualRecaudo}><a className="page-link" href="#" onClick={() => this.BuscarArrayResultado(actualRecaudo)}>{actualRecaudo}</a></li>);
                                                        return p;
                                                    })()}
                                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.cargarArchivos('RECA', actualRecaudo + 1)}><FontAwesomeIcon icon={faAngleRight} /></a></li>
                                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.cargarArchivos('RECA', ultimoRecaudo)}><FontAwesomeIcon icon={faAngleDoubleRight} /></a></li>
                                                </ul>
                                            </nav>
                                        </div>
                                        <div className="card-footer text-muted">
                                            <b>Pagina</b> <span className="badge bg-primary">{actualRecaudo}</span> <b>de</b> <span className="badge bg-primary">{ultimoRecaudo}</span> | <b>Registros</b> <span className="badge bg-success">{paginaRecaudo}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane fade" id="pills-refacturacion" role="tabpanel" aria-labelledby="pills-refacturacion-tab">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-xl-12">
                                                    <div className='row g-3'>
                                                        <div className="col-xl-2">
                                                            <select name="anosRefacturacion" id="anosRefacturacion"
                                                                className={"form-select form-select-sm"}
                                                                onChange={this.cambioValor}>
                                                                {
                                                                    anosRefacturacion.map((itemAnosRefacturacion) => (
                                                                        <option key={itemAnosRefacturacion.ANO_FACTURA} value={itemAnosRefacturacion.ANO_FACTURA}>{itemAnosRefacturacion.ANO_FACTURA}</option>
                                                                    ))
                                                                }
                                                            </select>
                                                        </div>
                                                        <div className="col-xl-4">
                                                            <input style={{ textTransform: 'uppercase' }} type="text" id="nombreArchivoRefacturacion" name="nombreArchivoRefacturacion" placeholder="Archivo" className="form-control form-control-sm" />
                                                        </div>
                                                        <div className="col-xl-3">
                                                            <button id="buttonFiltrarRefacturacion" name="buttonFiltrarRefacturacion" className="btn btn-secondary btn-sm" onClick={() => this.cargarArchivos('REFA', 1)}><FontAwesomeIcon icon={faFilter} />&nbsp;&nbsp;Filtrar</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <br />
                                            <div className="row">
                                                <table className="table table-hover table-condensed table-sm">
                                                    <thead className="thead-inverse">
                                                        <tr>
                                                            <th className="align-middle">MES</th>
                                                            <th className="align-middle">DEPARTAMENTO</th>
                                                            <th className="align-middle">MUNICIPIO</th>
                                                            <th className="align-middle">NOMBRE ARCHIVO</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            archivosRefacturacion.map((itemArchivosRefacturacion) => (
                                                                <tr key={itemArchivosRefacturacion.ID_TABLA}>
                                                                    <td>{itemArchivosRefacturacion.MES_FACTURA}</td>
                                                                    <td>{itemArchivosRefacturacion.DEPARTAMENTO}</td>
                                                                    <td>{itemArchivosRefacturacion.MUNICIPIO}</td>
                                                                    <td>{itemArchivosRefacturacion.RUTA}</td>
                                                                </tr>
                                                            ))
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                            <nav aria-label="Page navigation example">
                                                <ul className="pagination">
                                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.cargarArchivos('REFA', 1)}><FontAwesomeIcon icon={faAngleDoubleLeft} /></a></li>
                                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.cargarArchivos('REFA', actualRefacturacion - 1)}><FontAwesomeIcon icon={faAngleLeft} /></a></li>
                                                    {(() => {
                                                        let p = [];
                                                        p.push(<li className="page-item" key={actualRefacturacion}><a className="page-link" href="#" onClick={() => this.BuscarArrayResultado(actualRefacturacion)}>{actualRefacturacion}</a></li>);
                                                        return p;
                                                    })()}
                                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.cargarArchivos('REFA', actualRefacturacion + 1)}><FontAwesomeIcon icon={faAngleRight} /></a></li>
                                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.cargarArchivos('REFA', ultimoRefacturacion)}><FontAwesomeIcon icon={faAngleDoubleRight} /></a></li>
                                                </ul>
                                            </nav>
                                        </div>
                                        <div className="card-footer text-muted">
                                            <b>Pagina</b> <span className="badge bg-primary">{actualRefacturacion}</span> <b>de</b> <span className="badge bg-primary">{ultimoRefacturacion}</span> | <b>Registros</b> <span className="badge bg-success">{paginaRefacturacion}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card-footer text-muted"></div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Listar;